export const LIMIT = 15
export const WEEKDAYS_COUNT = 7
export const AMCHART_FAKE_KEY = 'CH]1{N)IU5.ZiP?^ae}xnMr$S7EDShkt'
export const REFERRAL_KEY = 'u'
export const REFERER_KEY = 'referrer'
export const OWN_OFFER_SOURCE = 'own'

export const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_campaign_id',
  'utm_placement',
  'utm_publisher_id',
  'utm_site_source_name',
  'utm_location',
  'utm_adset_name',
  'utm_adgroup_id',
  'utm_ad_name',
  'utm_ad_id',
  'utm_test'
]
